import { DETAILS } from '@web-platform/shared-universal-constants/src/routes';
import { FEATURE_DECISION_KEYS } from '@web-platform/shared-universal-constants-config';
import { getFeatureDecision } from '@web-platform/shared-universal-utils-frontend/src/config';
import { isAcornRequest } from '@web-platform/shared-universal-utils-frontend/src/helpers/isAcornRequest';
import { isFlightsBookingPanelScreen } from '@web-platform/shared-universal-utils-frontend/src/helpers/pageType';
import { matchPath } from 'react-router-dom';

import { LOCATION_CHANGED } from '../../../../../actions/location';

import type { LocationChangedAction } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { TransitionedToFlightBookingPanelState } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/transitionedToFlightBookingPanel';
import type { Location } from 'react-router-dom';

// `DETAILS` is the Banana booking-panel hash-route pattern (e.g.
// "#/details/:itineraryId/index/:resultIndex"). Strip the leading "#" so we
// can match against `location.hash.substring(1)` with `matchPath`.
const DETAILS_HASH_PATTERN = DETAILS.startsWith('#') ? DETAILS.substring(1) : DETAILS;

// Acorn always uses pathname detection. Banana uses pathname detection when
// BOOKING_PANEL_WITHOUT_MODAL is enabled and otherwise uses the control hash.
const isFlightsBookingPanelLocation = (location: Location | undefined): boolean => {
  if (!location) return false;
  if (isAcornRequest()) return isFlightsBookingPanelScreen(location);
  if (getFeatureDecision(FEATURE_DECISION_KEYS.BOOKING_PANEL_WITHOUT_MODAL)) {
    return isFlightsBookingPanelScreen(location);
  }
  if (!location.hash?.startsWith('#')) return false;
  return !!matchPath({ path: DETAILS_HASH_PATTERN, end: false }, location.hash.substring(1));
};

const hasPrevNavigation = (prevLocation: Location | undefined): boolean => {
  if (!prevLocation) return false;
  if (isAcornRequest()) return Boolean(prevLocation.pathname);
  if (getFeatureDecision(FEATURE_DECISION_KEYS.BOOKING_PANEL_WITHOUT_MODAL)) {
    return Boolean(prevLocation.pathname);
  }
  return true;
};

function transitionedToFlightBookingPanelReducer(
  state: TransitionedToFlightBookingPanelState = false,
  action: LocationChangedAction,
): TransitionedToFlightBookingPanelState {
  if (action.type !== LOCATION_CHANGED) return state;
  if (state) return isFlightsBookingPanelLocation(action.payload.location);
  return (
    isFlightsBookingPanelLocation(action.payload.location) &&
    hasPrevNavigation(action.payload.prevLocation) &&
    !isFlightsBookingPanelLocation(action.payload.prevLocation)
  );
}

export default transitionedToFlightBookingPanelReducer;

export const get = (
  state: TransitionedToFlightBookingPanelState,
): TransitionedToFlightBookingPanelState => state;
